<template>
    <Wrapper>
        <a id="main-content" class="fixed top-0" tabindex="-1"></a>

        <Breadcrumb :items="breadcrumbItems" />

        <h1 class="lg:w-1/2 header-1 mt-4 sm:mt-12"><T t="documents.title" /></h1>

        <div
            v-for="(category, i) in categories"
            :id="category.fragment_name ?? ''"
            :key="`category-${i}`"
            style="scroll-margin-top: 6rem"
        >
            <h2 class="lg:w-1/2 header-2 separator-border-top-line" :class="i === 0 ? 'mt-8' : 'mt-16 sm:mt-20'">
                {{ category.name }}
            </h2>

            <TransitionGroup name="fade" tag="div" class="grid grid-cols-12 base-responsive-gap mt-6">
                <div
                    v-for="(document, j) in getDocumentsInCategory(category.id)"
                    v-show="j < LIMIT * category.page"
                    :key="`document-${document.id}`"
                    class="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3"
                >
                    <DocumentCard :size="document.document_size" :title="document.name" :url="document.media" />
                </div>
            </TransitionGroup>

            <div v-if="LIMIT * category.page < getDocumentsInCategory(category.id).length" class="text-center mt-12">
                <Button
                    :label="$t('documents.load_more_button_label')"
                    class="p-button-secondary p-button-outlined"
                    @click.native="loadMore(category.id)"
                />
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';
import DocumentCard from '@/components/Cards/DocumentCard/DocumentCard.vue';

export default {
    name: 'DocumentsIndex',
    components: {
        Wrapper,
        DocumentCard,
    },
    async asyncData({ $axios, i18n, redirect, localePath }) {
        if (i18n.locale === 'en') {
            return await redirect(307, localePath('/'));
        }

        const LIMIT = 8;

        let categories = [];
        let documents = [];

        await $axios
            .$get('/documents')
            .then((res) => {
                documents = res.data;
                categories = documents.reduce((acc, curr) => {
                    if (!acc.find((x) => x.id === curr.category.id)) {
                        curr.category.page = 1;
                        acc.push(curr.category);
                    }

                    return acc;
                }, []);
            })
            .catch((err) => {
                console.log(err);
            });

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('documents.title'), 'documents']);

        return {
            breadcrumbItems,
            categories,
            documents,
            LIMIT,
        };
    },
    head() {
        return {
            title: this.$getPageTitle('documents.index'),
            meta: this.$getPageMetaData('documents.index'),
        };
    },
    methods: {
        getDocumentsInCategory(categoryID) {
            const docs = this.documents.filter((d) => d.category.id === categoryID);
            docs.sort((a, b) => new Date(b.published_at) - new Date(a.published_at));
            return docs;
        },
        loadMore(categoryID) {
            this.categories.find((x) => x.id === categoryID).page++;
        },
    },
};
</script>

<style scoped></style>
